import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import routeNames from './routeNames'

import Documents from '@/views/admin/Documents'
import Login from '@/views/Login'
import News from '@/views/admin/News'
import Users from '@/views/admin/Users'
import Brands from '@/views/admin/Brands'
import Malls from '@/views/admin/Malls'
import Entries from '@/views/admin/Entries'

import MyHome from '@/views/user/MyHome'
import MyDocuments from '@/views/user/MyDocuments'
import MyEntries from '@/views/user/MyEntries'
import MyProfile from '@/views/user/MyProfile'

Vue.use(Router)

/**
 * Ici l'ensemble des routes qui seront montées sous App.vue
 * Les pages sont insérées à l'emplacement du <router-view /> parent
 * Le premier parent se trouve dans App.vue
 */
export default new Router({
  routes: [
    {
      path: '/login',
      name: routeNames.login,
      component: Login,
      beforeEnter: (to, from, next) => {
        store.state.auth.isLogged ? next({name: routeNames.user.myHome}) : next()
      }
    },

    /* ===== USER ===== */
    {
      path: '/',
      name: routeNames.user.myHome,
      component: MyHome,
      beforeEnter: (to, from, next) => {
        store.getters['auth/isAdmin'] ? next({name: routeNames.brands}) : next()
      }
    },
    {
      path: '/entries',
      name: routeNames.user.myEntries,
      component: MyEntries,
      beforeEnter: (to, from, next) => {
        next(!store.getters['auth/isAdmin'])
      }
    },
    {
      path: '/documents',
      name: routeNames.user.myDocuments,
      component: MyDocuments,
      beforeEnter: (to, from, next) => {
        next(!store.getters['auth/isAdmin'])
      }
    },
    
    {
      path: '/profile',
      name: routeNames.user.myProfile,
      component: MyProfile
    },

    /* ===== ADMIN ===== */
    {
      path: '/admin/users',
      name: routeNames.users,
      component: Users,
      beforeEnter: (to, from, next) => {
        next(store.getters['auth/isAdmin'])
      }
    },
    {
      path: '/admin/news',
      name: routeNames.news,
      component: News,
      beforeEnter: (to, from, next) => {
        next(store.getters['auth/isAdmin'])
      }
    },
    {
      path: '/admin/documents',
      name: routeNames.documents,
      component: Documents,
      beforeEnter: (to, from, next) => {
        next(store.getters['auth/isAdmin'])
      }
    },
    {
      path: '/admin/brands',
      name: routeNames.brands,
      component: Brands,
      beforeEnter: (to, from, next) => {
        next(store.getters['auth/isAdmin'])
      }
    },
    {
      path: '/admin/malls',
      name: routeNames.malls,
      component: Malls,
      beforeEnter: (to, from, next) => {
        next(store.getters['auth/isAdmin'])
      }
    },
    {
      path: '/admin/entries',
      name: routeNames.entries,
      component: Entries,
      beforeEnter: (to, from, next) => {
        next(store.getters['auth/isAdmin'])
      }
    }
  ]
})
